import { FROZEN_EMPTY_ARRAY } from '@prophecy/utils/constants';
import { StableChildren } from '@prophecy/utils/react/StableChildren';
import { createContext, useContextSelector } from '@prophecy/utils/react/useZustandContext';
import { ReactNode } from 'react';

import { useBranchTabState } from './BranchTabState';
import { BranchTabState, LocalCheckout, LocalCheckoutDeletionResult } from './types';

const EMPTY_DELETION_RESULT: LocalCheckoutDeletionResult = {
  requested: 0,
  deleted: 0,
  skipped: 0,
  results: []
};

const defaultState: BranchTabState = {
  state: {
    summary: {
      totalCount: 0,
      unusedCount: 0,
      unusedAfterDays: 30,
      storageUsedBytes: 0
    },
    checkouts: FROZEN_EMPTY_ARRAY as LocalCheckout[],
    selectedIds: FROZEN_EMPTY_ARRAY as string[],
    loading: false,
    error: undefined
  },
  actions: {
    refresh: async () => undefined,
    deleteCheckouts: async () => EMPTY_DELETION_RESULT,
    toggleCheckout: () => undefined,
    toggleSelectAll: () => undefined,
    clearSelection: () => undefined
  }
};

const { Context: BranchTabContext, Provider: BranchTabContextProvider } = createContext<BranchTabState>(defaultState);

export function BranchTabProvider({ projectId, children }: { projectId: string; children: ReactNode }) {
  const value = useBranchTabState(projectId);
  return (
    <BranchTabContextProvider value={value}>
      <StableChildren>{children}</StableChildren>
    </BranchTabContextProvider>
  );
}

export function useBranchTab<Selected>(selector: (state: BranchTabState) => Selected): Selected;
export function useBranchTab(): BranchTabState;
export function useBranchTab(selector = (state: BranchTabState) => state) {
  return useContextSelector(BranchTabContext, selector);
}
